import { DEFAULT_LANGUAGE } from '@src/lang/config';
import { Trans } from '@utils/translation';

export const state = {
  cachedLanguage: DEFAULT_LANGUAGE,
};

export const getters = {};

export const mutations = {
  CACHE_LANGUAGE(state, currentLanguage) {
    state.cachedLanguage = currentLanguage
  },
};

export const actions = {
  /*
  * 設定語言
  * */
  setLanguage({ commit }, {language}) {
    return new Promise((resolve, reject) => {
      try {
        Trans.changeLanguage(language);
        commit('CACHE_LANGUAGE', language);
        resolve()
      }catch (e) {
        reject(new Error(e));
      }
    })
  },
};
